module.exports = __webpack_public_path__ + "assets/defaultBlue-bf5240.svg";